import React from "react";
import {Controller} from "react-hook-form";
import {Label} from "reactstrap";
import Flatpickr from "react-flatpickr";
import ValidationMsgComponent from "../ValidationMsgComponent";
import "flatpickr/dist/themes/material_green.css";

interface ControlledDateSelectorProps {
    label?: string;
    inputName: string;
    invalid?: boolean;
    control: any;
    rules?: any;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    errors?: string;
    isDisabled?: boolean;
    placeHolder?: string;
    minDate?: any;
    maxDate?: any;
    className?: string;
}

const ControlledDateSelector: React.FC<ControlledDateSelectorProps> = ({
                                                                           label,
                                                                           inputName,
                                                                           invalid,
                                                                           control,
                                                                           rules,
                                                                           isRequired,
                                                                           hasSideLabel,
                                                                           sideLabel,
                                                                           errors,
                                                                           isDisabled,
                                                                           placeHolder,
                                                                           minDate,
                                                                           maxDate,
                                                                           className
                                                                       }) => {

    return (
        <div className={`mb-1 ${className}`}>
            {isRequired && (
                <label className="form-label" htmlFor={inputName}>
                    {label} 
                </label>
            )}
            {!isRequired && (
                <Label className="form-label" htmlFor={inputName}>
                    {label}
                </Label>
            )}
            <div className="d-flex flex-row align-items-center">
                <Controller
                    name={inputName}
                    control={control}
                    rules={rules}
                    disabled={isDisabled}
                    render={({field}) => (
                        <Flatpickr
                            id={inputName}
                            placeHolder={placeHolder}
                            className={`form-control ${invalid && "is-invalid"}`}
                            options={{
                                enableTime: false,
                                noCalendar: false,
                                dateFormat: "Y-m-d",
                                minDate: minDate,
                                maxDate: maxDate,
                            }}
                            {...field}
                        />
                    )}
                />
                {hasSideLabel && <span className="ps-2">{sideLabel}</span>}
            </div>
            {invalid && (
                <ValidationMsgComponent
                    inputName={inputName}
                    invalid={invalid}
                    errors={errors}
                    rules={rules}
                />
            )}
        </div>
    );
};

export default ControlledDateSelector;
